import {sanityFetch} from 'utils/sanity.fetch';

import type {SiteSettingsQueryResult} from '../site/site-settings/query';
import {SITE_SETTINGS_QUERY} from '../site/site-settings/query';

import {FooterRender} from './render';

interface Props {
	isDraft: boolean;
}

export const FooterServer = async ({isDraft}: Props) => {
	const siteSettings = await sanityFetch<SiteSettingsQueryResult>({query: SITE_SETTINGS_QUERY});

	if (!siteSettings) {
		return null;
	}

	return <FooterRender siteSettings={siteSettings} isDraft={isDraft} />;
};
